import { useRef } from "react";
import type { ReactNode, ElementType } from "react";
import { m, useInView, type Variants } from "framer-motion";
import { stagger } from "@/lib/motion";

type RevealProps = {
  children: ReactNode;
  className?: string;
  variants?: Variants;
  amount?: number;
  once?: boolean;
  as?: "div" | "section" | "article" | "header" | "footer" | "ol" | "ul";
};

/**
 * Wrapper que dispara variants quando entra na viewport.
 * Por padrão usa o preset `stagger` (cascateia children que tenham variants próprios).
 * Use `variants={fadeUp}` para um único fade-up.
 */
export function Reveal({
  children,
  className = "",
  variants = stagger,
  amount = 0.2,
  once = true,
  as = "div",
}: RevealProps) {
  const ref = useRef<HTMLDivElement | null>(null);
  const inView = useInView(ref, { once, amount });

  const MotionTag = m[as] as ElementType;

  return (
    <MotionTag
      ref={ref}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      variants={variants}
      className={className}
    >
      {children}
    </MotionTag>
  );
}
